export enum RoadsoftHistoryField {
    ID = "id",
    MODIFIED_AT = "modifiedAt",
    USER = "user",
}

export enum RoadsoftConfigField {
    SUBSCRIPTION = "subscription",
    HISTORY = "history",
}

export enum RoadsoftSubscription {
    NOT_BOOKED = "NOT_BOOKED",
    PREMIUM = "PREMIUM",
    TASK_MANAGER = "TASK_MANAGER",
}

export interface RoadsoftHistory {
    [RoadsoftConfigField.SUBSCRIPTION]: RoadsoftSubscription;
    [RoadsoftHistoryField.MODIFIED_AT]: string;
    [RoadsoftHistoryField.USER]: string;
}

export interface RoadsoftConfig {
    [RoadsoftConfigField.SUBSCRIPTION]: RoadsoftSubscription;
    [RoadsoftConfigField.HISTORY]: RoadsoftHistory[];
}

export interface RoadsoftConfigForm {
    [RoadsoftConfigField.SUBSCRIPTION]: RoadsoftSubscription;
}
